// settings#profile — the "resend verification email" link that hides itself
// once clicked.
import { registerPage } from "../first"
import { mountSettingsApps } from "../settings"

export const SettingsProfilePage = {
  onDomReady(): void {
    mountSettingsApps()
  },
}

registerPage("SettingsProfilePage", SettingsProfilePage)
